// components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CircularProgress, Box, Alert } from '@mui/material';

const ProtectedRoute = ({
  children,
  requiredPermission,
  requiredPermissions = [],
  requiredRoles = []
}) => {
  const { isAuthenticated, loading, permissionsReady, hasPermission, hasAnyPermission, user } = useAuth();
  const location = useLocation();
  
  const needsPermissionCheck = Boolean(requiredPermission || requiredPermissions?.length > 0);
  const showLoader = loading || (isAuthenticated && needsPermissionCheck && !permissionsReady);

  if (showLoader) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role check (fallback if you still use roles)
  if (requiredRoles.length > 0) {
    const hasRole = requiredRoles.includes(user?.role?.name?.toLowerCase());
    if (!hasRole) {
      return <Alert severity="error">Access denied. Insufficient role.</Alert>;
    }
  }

  // Permission check
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <>
        {/* <Navigate to="/dashboard" state={{ from: location }} replace /> */}
        <Alert severity="error">You don't have permission: {requiredPermission}</Alert>
      </>
    );
  }

  if (requiredPermissions.length > 0 && !hasAnyPermission(requiredPermissions)) {
    return <Alert severity="error">You lack required permissions.</Alert>;
  }

  return children;
};

export default ProtectedRoute;